// extracted by mini-css-extract-plugin
export default {"list":"Catalog_list__lNKVe","card":"Catalog_card__7jA9I","btns":"Catalog_btns__HPenB"};